import { useState, useEffect } from 'react';

const Instruction = ({ challenge, openInstruction }) => {
  const [instructions, setInstructions] = useState([]);

  useEffect(() => {
    if (challenge?.instructions) {
      setInstructions(challenge.instructions);
    }
  }, [challenge]);

  return instructions.length > 0 ? (
    <div className='space-y-2'>
      <div className='flex items-end gap-2'>
        <h2 className='uppercase font-bold text-sm text-white'>instructions</h2>
        <button
          className='text-xs text-white/50'
          onClick={openInstruction}
        >
          view details
        </button>
      </div>
      <ul className='list-none rounded-xl px-4 py-3 bg-tertiary/20'>
        {instructions.map((item, index) => (
          <li
            key={index}
            className='flex items-center gap-2 text-sm'
          >
            <span>👉</span>
            <span className='text-white'>{item.instruction.title}</span>
          </li>
        ))}
      </ul>
    </div>
  ) : null;
};

export default Instruction;
